import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Typography from '@segment/matcha/components/Typography'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import { SectionWithAccordion } from 'views/Infrastructure/accordionData'

import AccordionSection from '../AccordionSection'

import ProcessingValidationTransformationImage from './ProcessingValidationTransformationImage'

const data = {
  anchorId: `validation-and-transformation`,
  overline: `Processing`,
  heading: `Validation and Transformation`,
  description: `Sometimes the data you’re collecting isn’t always in the format you want. It’s important that anyone—PMs, marketers, engineers—be able to help clean the data you’re collecting to match your needs.`,
  link: `https://github.com/segmentio/encoding`,
  linkText: `segmentio/encoding: Our zero-allocation JSON library (598 stars)`,
  accordionSection: SectionWithAccordion.VALIDATION_AND_TRANSFORMATION,
}

const ProcessingValidationTransformation: FC<PropsWithChildren<unknown>> = () => {
  const { anchorId, overline, heading, description, link, linkText, accordionSection } = data
  return (
    <Wrapper id={anchorId}>
      <SectionBase variant="2Col" copyVariant="wide">
        <Section.Copy>
          <CopyTextBase>
            <CopyText.Overline>{overline}</CopyText.Overline>
            <CopyText.Heading>{heading}</CopyText.Heading>
            <CopyText.Description tag="div">
              <CopyTextDescriptionSection>{description}</CopyTextDescriptionSection>
              <CopyTextDescriptionSection>
                <Typography variant="pLarge">
                  <a href={link}>{linkText}</a>
                </Typography>
              </CopyTextDescriptionSection>
              <AccordionSection section={accordionSection} />
            </CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <StyledSectionContents>
          <ProcessingValidationTransformationImage />
        </StyledSectionContents>
      </SectionBase>
    </Wrapper>
  )
}

const CopyTextDescriptionSection = styled.div`
  margin-bottom: 32px;
`

const Wrapper = styled.section`
  display: grid;
`

const StyledSectionContents = styled(Section.Contents)`
  margin: auto;
`

export default ProcessingValidationTransformation
